import { ComponentPropsWithoutRef, FC, ReactNode } from "react";
import Typography from "./Typography";

export type ReasonItem = {
  icon: ReactNode;
  title: string;
  body: ReactNode;
};

export type ReasonsSectionData = {
  title: ReactNode;
  subtitle?: ReactNode;
  items: ReasonItem[];
};

type AlternativeReasonsSectionProps = {
  data: ReasonsSectionData;
} & ComponentPropsWithoutRef<"section">;

const AlternativeReasonsSection: FC<AlternativeReasonsSectionProps> = ({
  data,
  ...rest
}) => {
  return (
    <section {...rest} className={`${rest.className ?? ""}`}>
      <Typography variant="h2" component="h2" className="text-center">
        {data.title}
      </Typography>
      {data.subtitle && (
        <Typography
          variant="body1"
          className="mt-4 text-slate-600 text-center max-w-3xl mx-auto"
        >
          {data.subtitle}
        </Typography>
      )}
      <div className="mt-16 grid gap-6 md:grid-cols-2">
        {data.items.map((item) => (
          <article
            key={item.title}
            className="flex flex-col items-start gap-4 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm"
          >
            <div className="flex h-12 w-12 items-center justify-center rounded-xl bg-violet-100 text-violet-600 [&>svg]:h-6 [&>svg]:w-6">
              {item.icon}
            </div>
            <Typography variant="h4" component="h3">
              {item.title}
            </Typography>
            <Typography variant="body2" className="text-slate-600">
              {item.body}
            </Typography>
          </article>
        ))}
      </div>
    </section>
  );
};

export default AlternativeReasonsSection;
